'use strict'

module.exports = require('./utils/interpolate').interpolateArray(require('./hex/inferno.json'))



//////////////////
// WEBPACK FOOTER
// ./~/scale-color-perceptual/inferno.js
// module id = 849
// module chunks = 0